export enum AccessorialsComponentDisplayModesEnum {
	CHIP = 'chip',
	LIST = 'list',
	EMIT = 'emit'
}
